export const getStyles = () => ({
  seeExampleContainer: {
    marginBottom: '20px',
    marginLeft: '11px',

    '& .example-message': {
      marginBottom: 30,
    },
  },
});
